import FormItemSpecification from './FormItemSpecification'
import SkuList from './FormItemSkuList'
import FormItemExtendList from './FormItemExtendList.vue'
import RuleSortBtn from './RuleSortBtn'
import SpecsValuesSort from './SpecsValuesSort'
import { cloneDeep } from 'lodash';

export const FormItemSkuList = SkuList
const needGrayPlatforms = ['fxg', 'tb', 'pdd', 'kuaishou', 'alibaba'];
export const specification_mixin = {
  provide: {
    noSpPic: false, // 取消规格图片
    disabledSpName: false, // 禁用规格名输入
    disabledSpValue: false // 禁用规格值输入 
  },
  inject: {
    isGroupPuhuo: { default: false } // 是否组合铺货
  },
  components: {
    FormItemSkuList,
    FormItemExtendList,
    FormItemSpecification,
    RuleSortBtn,
    SpecsValuesSort
  },
  data() {
    return {
      specifications: [], // 商品规格
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      skuList: [], // 规格明细
      extendAttr: [],   // 扩展属性
      allSkuSpecifications: {},
    }
  },
  computed: {
    // 生成sku默认值
    computedValueForm() {
      let form = {}
      let skuTableCols = this.skuTableCols_all || this.skuTableCols2 || this.skuTableCols || [];
      skuTableCols.forEach(item => {
        if (item.input) {
          form[item.prop] = ''
        }
      })
      const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
      form.baseItemId = this[self_form_key].baseItemId
      return form
    },
    specificationNames() {
      return this.specifications.map(item => {
        let nameObj = {
          name: item.name
        }
        if (item.nameKey) {
          nameObj.nameKey = item.nameKey
        }
        return nameObj
      })
    },
    skuExtendTableCols() {
      const skuAttr = this.skuAttr.map(item => {
        return {
          attrID: item.attrID,
          name: item.name,
        };
      });
      const cols = skuAttr.concat(this.extendAttr);
      return cols;
    }
  },
  watch: {
    specifications: {
      // 监听规格信息生成规格详情列表
      handler(v) {
        this.createSkuListBySpecs(v)
        this.specificationsFieldChanged && this.specificationsFieldChanged()
      },
      immediate: true,
      deep: true
    },
    extendAttr(extendAttr) {
      if(!this.skuList.length || !extendAttr.length) return
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
      this.skuList.forEach(item => {
        const _skuid = item._skuid;
        const itemSkuSp = this.allSkuSpecifications[_skuid] || [];
        let extendSpecifications = [];
        extendAttr.forEach(extend => {
          const currItem = itemSkuSp.find(skuSp => skuSp.name === extend.name && skuSp.extendValues && skuSp.extendValues.attrType == 2) || {}
          extendSpecifications.push({
            name: extend.name,
            checked: true,
            extendValues: {
              attrType: 2,
            },
            checked: true,
            nameKey: item.attrID,
            value: undefined,
            valueKey: undefined,
            ...currItem
          })
        })
        item[self_skuSpecifications_key] = item[self_skuSpecifications_key].concat(extendSpecifications)
      })
    }
  },
  methods: {
    createSkuListBySpecs(v) {
      v = v || this.specifications
      if (this.showPddSpec) return; // 如果pdd类目属性带出来规格
      if (window.__spcificationRemark_changed) return window.__spcificationRemark_changed = false;
      // debugger;
      const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
      
      // 规格名勾选变化时，skuList的_skuid也需要随着更改, 目前只有淘宝用到
      if(this.isTb || this.isAlibaba) {
        v = v.filter(sp => sp.checked)
        if(!v.length) return
        if(window.__spcificationSpCheckbox_changed) {
          this.initSelfSkuList()
        }
      }
      if (v.length < 1 || !this[self_form_key]) {
        this.skuList = []
        return
      }
      // 有没创建规格值的的规格就不生成skulist
      let hasNoValues = false

      if (!v.filter(item => item?.name).length) {
        hasNoValues = true
      }
      v.filter(item => item?.name && item?.values?.length).forEach(item => {
        if (hasNoValues) return
        if (item.values.length) return
        if (item.values.filter(i => i.checked).length) return
        hasNoValues = true
      })
      // debugger;
      if (hasNoValues) {
        this.skuList = []
      } else {
        let _skuList = []
        const that = this
        const allIsEdited = v.some(s => s.isEdited)
        const originSkuList = cloneDeep(that[self_form_key].skuList)
        const oldSkuList = cloneDeep(that.skuList)
        const forEach = (arr, index = 0, c_arr = []) => {
          // 取到最后一层开始作业务逻辑
          if (arr.length === index) {
            // 若有值为空或未勾选不做任何处理
            if (c_arr.some(item => (!item.value || !item.checked))) {
              return;
            }
            const isEdited = c_arr.some(s => s.isEdited)
            const isGray = needGrayPlatforms.includes(this.platform) ? !(isEdited || allIsEdited) : false
            const valueKeys = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey)
            const _skuid = valueKeys.join('-') // 生成skuid
            const _skuSpecifications = c_arr.map((item,index) => { //生成sku明细
              const _sp = {
                checked: that.getChecked(v[index].nameKey, item.valueKey, v),
                name: v[index].name,
                value: item.value,
                nameKey: v[index].nameKey,
                valueKey: item.valueKey
              }
              if (['pdd', 'xhs', 'alibaba','shein'].includes(that.platform)) { // pdd 
                _sp.propId = item.propId;
                _sp.propValueId = item.propValueId;
              }
              if (that.isJd) {
                // 京东平台需要存储propId 及 propValueId
                const _spItem = that._mix_getSpItem(v[index].nameKey, item.valueKey, v)
                if (_spItem) {
                  _sp.propId = _spItem.propId
                  _sp.propValueId = _spItem.propValueId
                  _sp.extendValues = _spItem.extendValues
                }
              }
              // 非sku预览图只可预览的表单且当前商品图片规格没改过，需要在原self_form里面skuList字段取图片数据
              // 而不是通过_skuSpecifications中取
              const getImageUrl = (sku, key) => sku ? sku[key][0].imageUrl || '' : item.imageUrl || '';

              if (!that.skuImgOnlyPreview && !window.__spcificationImg_changed) {
                const selfSku = that.findSkuListItem(originSkuList, valueKeys).item
                const thisSku = that.findSkuListItem(oldSkuList, valueKeys).item
                if (selfSku && !window.__spcificationCheckbox_changed) {
                  _sp.imageUrl = selfSku.imageUrl || getImageUrl(selfSku, self_skuSpecifications_key);
                } else {
                  // 备注和勾选修改
                  _sp.imageUrl = getImageUrl(thisSku, self_skuSpecifications_key);
                }
              } else {
                const thisSku = that.findSkuListItem(oldSkuList, valueKeys).item
                if (window.__spcificationImg_changed && _skuid.includes(window.__spcificationImg_changed)) {
                  _sp.imageUrl = item.imageUrl || '';
                } else {
                  _sp.imageUrl = getImageUrl(thisSku, self_skuSpecifications_key);
                }
              }
              return _sp
            })
            // 1. 现在当前skuList中找有无数据 if
            // 2. 在self_form中找有无数据    else if
            // 3. 生成一个全新skuitem        else
            
            let skuItem;
            // --- 1
            const thisSkuIndex = that.findSkuListItem(oldSkuList, valueKeys).index
            // console.log('oldSkuList', _skuid, valueKeys, thisSkuIndex, cloneDeep(oldSkuList)) 

            let thisSku = undefined;
            if (thisSkuIndex > -1) {
              thisSku = oldSkuList[thisSkuIndex];
              // 找到后删除，避免后续重复匹配
              oldSkuList.splice(thisSkuIndex, 1);
            }
            if (thisSku) {
              skuItem = { ...thisSku, isGray: thisSku.isGray ? isGray : thisSku.isGray };
              if (window.__spcificationImg_changed && _skuid.includes(window.__spcificationImg_changed)) {
                this.handleFxgSkuPictureUrl(skuItem, _skuSpecifications)
              }
            } else {
              const selfSkuObj = that.findSkuListItem(originSkuList, valueKeys)
              let selfSkuIndex = selfSkuObj.index
              let selfSku = undefined;
              if (selfSkuIndex !== undefined && selfSkuIndex > -1) {
                selfSku = originSkuList[selfSkuIndex];
                // 找到后删除，避免后续重复匹配
                originSkuList.splice(selfSkuIndex, 1);
              }
              if (selfSku) {
                that.allSkuSpecifications[_skuid] = cloneDeep(selfSku[self_skuSpecifications_key]);
                skuItem = { ...selfSku, _skuid };
                (skuItem.skuFieldDescriptorList || []).forEach(attr => {
                  skuItem[attr.name] = attr.defaultValue ?? skuItem[attr.name];
                });
                // 淘宝删除id, 保存时统一替换skuList
                if(['tb', 'alibaba'].includes(this.platform) && !this.isGroupPuhuo) {
                  skuItem.id = null
                }
                this.handleFxgSkuPictureUrl(skuItem, _skuSpecifications)
              } else if (['tb', 'alibaba'].includes(this.platform)) {
                skuItem = {
                  ...cloneDeep(oldSkuList[0]),
                  _skuid,
                  baseSkuId: '',
                  skuId: '',
                  skuNumIid: '',
                  isAdd: true,
                  isGray
                };
                // 新增的规格明细值设为空
                (skuItem.skuFieldDescriptorList || []).forEach(attr => {
                  attr.defaultValue = '';
                  skuItem[attr.name] = ''
                });
              } else {
                skuItem = {
                  isGray,
                  _skuid,
                  ...cloneDeep(that.computedValueForm),
                };
                this.handleFxgSkuPictureUrl(skuItem, _skuSpecifications)
              }

              // 生成的销售价，成本价，市场价，库存默认为0
              const defaultValues = {
                marketPrice: 0,
                salesPrice: 0,
                baseSellingPrice: 0,
                stock: 0,
                purchasePrice: 0,
                weight: 0
              };
    
              Object.entries(defaultValues).forEach(([key, defaultValue]) => {
                skuItem[key] ||= defaultValue;
              });
            }
            if(this.platform === 'fxg'){
              if(skuItem.skuStatus === null || skuItem.skuStatus === undefined || skuItem.skuStatus === ''){
                skuItem.skuStatus = true
              }
              skuItem.skuStatus = !!skuItem.skuStatus
              // if(this.skuPictureRule?.support){
              //   skuItem.skuPictureErrMsg = skuItem.skuPictureErrMsg || ''
              //   if(!skuItem.skuPictureUrl){
              //     // let skuSpecifications = skuItem[self_skuSpecifications_key]
              //     let obj = _skuSpecifications.find(item => item.imageUrl) || {}
              //     skuItem.skuPictureUrl = obj.imageUrl || ''
              //   }
              // }
            }
            skuItem[self_skuSpecifications_key] = _skuSpecifications
            _skuList.push(skuItem)
            return;
          }
          // 取出一层
          let currItem = arr[index]
          // 此层值循环
          currItem.values.forEach(c => {
            // 每个值再递归取
            forEach(arr, index + 1, c_arr.concat(c))
          })
        }
        forEach(v?.filter((item) => item?.name));

        if(this.source === 'edit_base'){
            // 分销价格等级处理 
            _skuList.forEach(item => {
                let distributionLevelPriceObj = {}
                if(item.distributionLevelPrice && item.distributionLevelPrice !== '[]'){
                  try{  
                    let distributionLevelPrice = JSON.parse(item.distributionLevelPrice)
                    distributionLevelPrice.forEach(d => {
                      let key = 'distributionPrice_'+ d.level
                      distributionLevelPriceObj[key] = d
                    });
                  }catch(e){}
                }else{
                  Array.from({ length: 15 }, (_, i) => i+1).forEach(d => {
                    let key = 'distributionPrice_'+ d;
                    distributionLevelPriceObj[key] = {
                      controlPrice: 0,
                      controlPriceSetType: 1,
                      distributorPrice: 0,
                      distributorPriceSetType: 1,
                      level: d,
                    }
                  })
                }
                item.distributionLevelPriceObj = distributionLevelPriceObj
            });
        }

        if(this.spotPresaleIntoSkuList && this.self_form.sellType === 3) {  // 快手发货时效加入SkuList
          _skuList = this.spotPresaleIntoSkuList(_skuList)
        }
        if(this.isXhs){
          if(this.spotPresaleIntoSkuList && this.self_form.deliveryTimeObject.option == 4) {  // 小红书发货时效加入SkuList
            _skuList = this.spotPresaleIntoSkuList(_skuList)
          }
        }
        this.skuList = _skuList;

        if(this.isBase){// 基础资料
          // 放在最后执
          this.getSkuErpStock(_skuList)
        }
        
        window.__spcificationImg_changed = ''
        window.__spcificationCheckbox_changed = false;
        window.__spcificationSpCheckbox_changed = false;
      }
    },
    handleFxgSkuPictureUrl(skuItem, _skuSpecifications) {
      if(this.platform === 'fxg' && this.skuPictureRule?.support){
        skuItem.skuPictureErrMsg = skuItem.skuPictureErrMsg || ''
        if(!skuItem.skuPictureUrl){
          let obj = _skuSpecifications.find(item => item.imageUrl) || {}
          skuItem.skuPictureUrl = obj.imageUrl || ''
        }
      }
    },
    findSkuListItem(list, valueKeys) {
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
      const newValueKeys = valueKeys.reduce((newKeys, key) => {
        if(typeof key === 'string'){
          newKeys.push(...key.split('______')) // 淘宝、天猫‘选择展示模式’切换时的特殊处理
        }else{
          newKeys.push(key)
        }
        return newKeys
      }, [])
      const index = list?.findIndex(sku => {
        const skuValueKeys = (sku[self_skuSpecifications_key] || []).filter(item => !!item.valueKey).map(item => item.valueKey) 
        let isMatch = valueKeys.every(key => skuValueKeys.includes(key))
        if(!isMatch) {
          isMatch = newValueKeys.every(key => skuValueKeys.includes(key))
        }
        return isMatch
      })
      return {
          index, 
          item: index > -1 ? cloneDeep(list[index]) : null
      }
    },
    // 根据nameKey、valueKey获取checked值
    getChecked(nameKey, valueKey, specifications) {
      try {
        return specifications.find(item => item.nameKey === nameKey).values
        .find(item => item.valueKey === valueKey).checked
      } catch (error) {
        return false
      }
    },
    // 根据nameKey、valueKey获取指定的规格值对象
    _mix_getSpItem(nameKey, valueKey, specifications) {
      try {
        return specifications.find(item => item.nameKey === nameKey).values
        .find(item => item.valueKey === valueKey)
      } catch (error) {
        return null
      }
    },
    // 校验规格信息
    validateSpecifications(specifications) {
      if((this.platform == 'base' && this.pureGoods.pureType === 1) || this.isPureType === 1) {
        return true
      }
      // if (!this.skuList.length) {
      //   return '请补充商品规格及规格明细';
      // }
      if(!this.isGroupPuhuo) {
        if (this.isJd && this.skuList.find(sku => !sku.isGray &&!sku.outerSkuId)) {
          return '有未匹配到的商家编码，请到基础资料调整规格'
        }
      }

      const errorReg = /[|,\^]+/ // 规格名与值不允许输入 ^|, 三种符号

      let errmsg = null;
      specifications = specifications || this.specifications;

      if (this.isKuaishou) {
        // 快手平台下，不同规格下的规格值都不能重复
        let spValuesMap = []
        let spvalueRepeat = false
        specifications.forEach((sp, spi) => {
          if (spvalueRepeat) return;
          spValuesMap.forEach(spvm => {
            if (spvalueRepeat) return;
            sp.values.forEach(spv => {
              if (spvalueRepeat) return;
              if (spv.checked && spvm.includes(spv.value)) {
                spvalueRepeat = `不同规格下的规格值都不能重复,重复的规格值【${spv.value}】`
              }
            })
          })
          spValuesMap[spi] = sp.values.map(spv => {
            return (spv.checked && spv.value) ? spv.value : false
          }).filter(Boolean)
        })
        if (spvalueRepeat) {
          return spvalueRepeat;
        }
      }
      let specNames = []
      for (let index = 0; index < specifications.length; index++) {
        const specification = specifications[index];
        if (!specification.name) {
          // this.$message.error('请补充规格名')
          return '请补充规格名'
        }
        if(specNames.includes(specification.name)) {
          return `规格名【${specification.name}】重复`
        } 
        specNames.push(specification.name)
        if (this.needValiSymbol && errorReg.test(specification.name)) {
          return `规格名:${specification.name} 请勿包含^|,符号`
        }

        

        let valiArr = [] // 有效的规格值
        for (let vindex = 0; vindex < specification.values.length; vindex++) {
          const value = specification.values[vindex]
          if (!value.checked) {
            // 未勾选不校验
            continue
          }
          if (this.isPdd) {
            // pdd 必须有propId
            if (!value.parentSpecId) {
              return `规格名列表项不包含 规格名[${specification.name}], 请修改规格名[${specification.name}]`
            }
            // 拼多多规格值+备注不超过18个字
            const note = this.canNoteItems[index]?.canNote ? (value.note || '') : '';
            const valueNoteLen = ((value.value || '') + note).length;
            if (valueNoteLen > 40) {
              return `规格名[${specification.name}]下的规格值:${value.value || ''} + 备注超过40个字，请修改`;
            }
          }

          if(value.valueErrorMsg) {
            return value.valueErrorMsg
          }
          if (!value.value) {
            // 校验规格值不能为空
            errmsg = `${specification.name}规格下的规格值未完善`
            return errmsg
          }
          if (value.value.length>=40 && this.platform == 'wxsph') {
            // 校验规格值不能为空
            errmsg = `${specification.name}规格下的规格值: ${value.value} , 不能超过40`
            return errmsg
          }
          if (this.needValiSymbol && errorReg.test(value.value)) {
            return `规格值:${value.value} 请勿包含^|,符号`
          }
          
          if (this.specification_needImg && index === 0 && !value.imageUrl) {
            // 该表单是否需要图片 && 第一个规格需要校验图片 && 图片不能为空
            errmsg = `${specification.name}规格下的图片未完善`
            return errmsg
          }
          if (valiArr.includes(value.value)) {
            errmsg = `${value.value}规格值重复`
            return errmsg
          }
          valiArr.push(value.value)
        }
        continue;
      }
      const validSkuList = this.validateSkuList();
      if (validSkuList !== true) return validSkuList;

      const validateSkuExtendList = this.validateSkuExtendList();
      if (validateSkuExtendList !== true) return validateSkuExtendList;

      if (this.platform === 'tb') {
        const validStdList = this.validateStdList();
        if (validStdList !== true) return validStdList;
      }
      return validSkuList;
    },
    getValidatorFn(item) {
      const { input, attrs, visibleFn, unvisible,isCustomValidator } = item
      if(!isCustomValidator && ((attrs?.requiredFn ? !attrs.requiredFn() : attrs?.noRequired) || unvisible || (visibleFn && !visibleFn()))) {
        return null
      } 
      return input.validator || this.validateVoid
    },
    // 校验skuList和扩展的工业属性
    validateSkuList() {
      let skuTableCols = this.skuTableCols_all || this.skuTableCols2 || this.skuTableCols || [];
      // 需要校验的props
      const props = skuTableCols.filter(item => item.input).map(item => {
        return {
          ...item,
          prop: item.prop,
          label: item.attrs.label,
          // validator: item.input.validator ? item.input.validator : !item.attrs.noRequired ? this.validateVoid : null,
          validator: this.getValidatorFn(item),
        }
      })
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications';
      // debugger;
      // 分销商基础资料里没有绑定供分销关系的sku做了不可以编辑处理，相应的校验也就不需要了
      let _skuList = (this.isDistribution && this.source === 'edit_base') ? this.skuList.filter(i => i.supplierItemId) : this.skuList;
      for(let index = 0; index < _skuList.length; index++) {
        const sku = _skuList[index]
        if (sku.disabled || sku.isGray) continue;
        if (this.isPdd) { // pdd 要校验 预览图
          // const skuSpec0 = sku[self_skuSpecifications_key] && sku[self_skuSpecifications_key][0]
          // if (skuSpec0 && (!skuSpec0.imageUrl || sku.imgUrlError)) {
          //   return '请完善价格库存列表预览图!';
          // }
          if(!sku.skuImg) {
            return '请完善列表预览图!';
          }
          // sku编码 校验改成根据列配置来，列配置没有就不校验 （店铺商品页面内不需要sku编码）
          // if (!sku.outSkuSn && props.some(p => p.prop === 'outSkuSn')) {
          //   return 'sku编码为空，请绑定商家编码!';
          // }
        }
        
        if(this.platform == 'yyjk'){
          if(!String(sku.weightForUnit)){
            return '请输入重量!';
          }
          if(!sku.weightUnit){
            return '请输入重量单位!';
          }
        }
        for (let pidex = 0; pidex < props.length; pidex++) {
          const prop = props[pidex];
          if (prop.validator) {
            const errmsg = prop.validator(sku[prop.prop], prop, sku)
            if (errmsg) {
              // this.$message.error(errmsg)
              return errmsg
            }
          }
        }
      }
      return true

    },
    validateSkuExtendList() {
      if(!this.$refs.FormItemExtendListRef) {
        return true;
      } else {
        const extendValues = this.$refs.FormItemExtendListRef.getValueForm();
        // 需要校验的props
        const props = this.skuExtendTableCols.filter(item => item.inputType && item.required).map(item => {
          return {
            ...item,
            prop: item.name,
            label: item.name,
            validator: this.validateVoid
          }
        })

        for (let pidex = 0; pidex < props.length; pidex++) {
          const prop = props[pidex];
          if (prop.validator) {
            for(let extendVal in extendValues) {
              const errmsg = prop.validator(extendValues[extendVal][prop.name], prop)
              if (errmsg) {
                return errmsg
              }
            }
          }
        }
      }

      return true
    },
     // 校验空值
    validateVoid(value, prop, sku) {
      if(sku.isGray || (prop.disabledFn && prop.disabledFn(sku))) return false
      if (value === "" || value === undefined || value === null || (Array.isArray(value) && value.length === 0 && prop.input?.type === 'select' && prop.input?.attrs?.multiple)) {
        return `商品明细中${prop.label || prop.name}请勿输入空值`
      }
      return false
    },
    // 清空数据
    // 由于dialog关闭未销毁实例，会有数据缓存问题，需要在弹窗关闭时调用一下
    clear_specification() {
      this.specifications = []
    },
    // 获取规格与规格明细数据
    getSpecificationData(specifications) {
      specifications = specifications || JSON.parse(JSON.stringify(this.specifications || []))
      const self_form_key = this.mixinsFormKey ? this.mixinsFormKey : 'self_form'
      const self_skuSpecifications_key = this.skuSpecificationsKey ? this.skuSpecificationsKey : 'skuSpecifications'
      
      let origin_skuList = this[self_form_key].skuList
      if (!Array.isArray(origin_skuList)) {
        return [];
      }
      const checkedValueKeys = []
      // 平台资料需要对规格的checkbox做一些处理
      specifications.forEach((item, index) => {
        item.values.forEach((v, vi) => {
          // 如果未勾选，需要获取之前的数据进行填充
          v.name = item.name;
          v.nameKey = item.nameKey;
          v.valueKey = v.valueKey || v.value;
          if (v.checked) {
            checkedValueKeys.push(v.valueKey)
          } 
          if (v.extendValues && this.platform === 'jd') {
            const extendValues = {};
            Object.entries(v.extendValues || {}).forEach(([key, val]) => {
              if (val?.value) {
                extendValues[key] = val;
              }
            });
            v.extendValues = extendValues;
          }
          if(index !== 0) {
            delete v.imageUrl
          }
          delete v.imgErrMsg
          delete v.valueErrorMsg
          delete v.isEdited
        })
        delete item.isEdited
        delete item.valueUnit
        if(this.platform === 'jd') {
          delete item.valueItemRule
          delete item.id
        }
      })

      let skuList = []
      if (this.isBaseInfo || ['fxg', 'tb', 'pdd', 'alibaba', 'xy','shein','jdms'].includes(this.platform) ) { // 基础表单skuList直接取
        skuList = cloneDeep(this.skuList).filter(item => {
          return !item.isGray
        })
      } else { // 平台的skuList要取对应form中的skuList 且将当前skulist数据对应填入
        const copyImgToSkuImg = (sItem) => { // pdd 需要更新skuImg
            const _skuSpecifications = sItem.skuSpecifications;
            const imgUrl = _skuSpecifications[0] && _skuSpecifications[0].imageUrl;
            if (imgUrl && (!this.isPdd || this.pddConfig?.isUpdateSkuImg === 1)) {
              sItem.skuImg = imgUrl;
            }
        }
        let origin_skuList = this[self_form_key].skuList
        const noRepetitionOriginSkuList = Array.from(new Set(origin_skuList.map(sku => sku._skuid))).map(_skuid => origin_skuList.find(sku => sku._skuid === _skuid));
        if(this.isKuaishou && this.spotPresaleList.length) {
          // 对skuList 去重， 快手平台可能会出现相同_skuid,且发货时效不同
          noRepetitionOriginSkuList.forEach(sku => {
            const _skuid = sku._skuid
            const originIdList = origin_skuList.filter(sku => sku._skuid === _skuid && sku.id).map(sku => sku.id) // 初始skuList的id数据
            this.spotPresaleList.forEach((spotPresale, spotPresaleIndex) => {
              let skuItem = {}
              let findSku = this.skuList.find(sku => sku._skuid === _skuid && sku.spotPresaleName === spotPresale)
              if(findSku) {
                skuItem = cloneDeep(findSku)
              } else {
                const skus = origin_skuList.filter(sku => sku._skuid === _skuid)
                let findItem = cloneDeep(skus[spotPresaleIndex] || skus[0])
                let skuSpecifications = findItem[self_skuSpecifications_key]
                skuSpecifications.forEach(skuSpec => {
                  skuSpec.checked = checkedValueKeys.includes(skuSpec.valueKey)
                })
                skuItem = { ...findItem, [self_skuSpecifications_key]: skuSpecifications}
              }
              skuItem[self_skuSpecifications_key].push({
                checked: true,
                name: '发货时效',
                nameKey: '发货时效',
                value: spotPresale,
                valueKey: spotPresale,
              })
              skuItem.id = originIdList[spotPresaleIndex] || ''
              skuList.push(skuItem)
            })
          })
        } else if(this.isXhs && this.spotPresaleList.length){
          noRepetitionOriginSkuList.forEach(sku => {
            const _skuid = sku._skuid
            const originIdList = origin_skuList.filter(sku => sku._skuid === _skuid && sku.id).map(sku => sku.id) // 初始skuList的id数据
            this.spotPresaleList.forEach((spotPresale, spotPresaleIndex) => {
              let skuItem = {}
              let findSku = this.skuList.find(sku => sku._skuid === _skuid && sku.spotPresaleName === spotPresale)
              if(findSku) {
                skuItem = cloneDeep(findSku)
              } else {
                const skus = origin_skuList.filter(sku => sku._skuid === _skuid)
                let findItem = cloneDeep(skus[spotPresaleIndex] || skus[0])
                let skuSpecifications = findItem.skuSpecifications
                skuSpecifications.forEach(skuSpec => {
                  skuSpec.checked = checkedValueKeys.includes(skuSpec.valueKey)
                })
                skuItem = { ...findItem, skuSpecifications: skuSpecifications}
              }
              // 判断是否包含"天"来设置不同的发货时效对象
              const isSpotGoods = spotPresale.includes('天');
              const _type = spotPresale =='当日发货'?"TODAY" : "RELATIVE_TIME_NEW";
              skuItem.deliveryTimeObject = {
                option: 4,
                type: _type,
                deliveryFlag: isSpotGoods ? 2 : 1
              }
              // deliveryFlag 代表现货时间 2 代表预售时间
              
              if (isSpotGoods) {
                skuItem.deliveryTimeObject.preSaleTime = this.getDeliveryTimeValue(spotPresale)
              } else {
                skuItem.deliveryTimeObject.time = this.getDeliveryTimeValue(spotPresale)
              }
              // skuItem.skuSpecifications.push({
              //   checked: true,
              //   name: '发货时效',
              //   nameKey: '发货时效',
              //   value: spotPresale,
              //   valueKey: spotPresale,
              // })
              skuItem.id = originIdList[spotPresaleIndex] || ''
              skuList.push(skuItem)
            })
          })
        } else {
          const curSkuList = cloneDeep(this.skuList || [])
          origin_skuList.map((item,index) => {
            let findIndex = curSkuList.findIndex(s => s._skuid === item._skuid)
            if(findIndex === -1) {
              const itemSkuValueKeys = item[self_skuSpecifications_key].map(skuSpecs => skuSpecs.valueKey)
              findIndex = curSkuList.findIndex(sku => {
                const curSkuValueKeys = sku[self_skuSpecifications_key].map(skuSpecs => skuSpecs.valueKey)
                return itemSkuValueKeys.every(valueKey => curSkuValueKeys.includes(valueKey)) || curSkuValueKeys.every(valueKey => itemSkuValueKeys.includes(valueKey))
              })
            }
            const _curr_sku = curSkuList[findIndex]
            let sku = {
              ...item,
            }
            if (_curr_sku) {
              // 当前sku在sku_table上, 将当前sku覆盖源sku
              _curr_sku[self_skuSpecifications_key].forEach(sp => {
                sp.valueKey = sp.valueKey || sp.value
                sp.checked = true
                if (sp.extendValues && this.platform === 'jd') {
                  const extendValues = {};
                  Object.entries(sp.extendValues || {}).forEach(([key, val]) => {
                    if (val?.value) {
                      extendValues[key] = val;
                    }
                  });
                  sp.extendValues = extendValues;
                }
              })
              sku = {
                ...sku,
                ..._curr_sku
              }
              curSkuList.splice(findIndex, 1)
            } else {
              // 源sku不动 只更改checked值
              sku[self_skuSpecifications_key].forEach(sp => {
                sp.valueKey = sp.valueKey || sp.value
                if (checkedValueKeys.includes(sp.valueKey)) {
                  sp.checked = true
                } else {
                  sp.checked = false
                }
              })
            }
            if (this.isPdd) {
              copyImgToSkuImg(sku);
            }
            skuList.push(sku)
          })
          // 去重
          const skuidList = []
          skuList = skuList.filter(item => {
            if(item.isGray) return false
            if(!skuidList.includes(item._skuid)) {
              skuidList.push(item._skuid)
              return true
            }
          })
        }
        // if (this.isGroupPuhuo) {
        //   // 组合铺货需要将disabled的sku塞入进来
        //   this.skuList.forEach(sku => {
        //     if (sku.disabled) {
        //       sku[self_skuSpecifications_key].forEach(sp => {
        //         if (checkedValueKeys.includes(sp.valueKey)) {
        //           sp.checked = true
        //         } else {
        //           sp.checked = false
        //         }
        //       })
        //       skuList.push(sku)
        //     }
        //   })
        // }
      }
      return [specifications, skuList]
    }
  }
}

export default FormItemSpecification
